module.exports = __webpack_public_path__ + "img/años.852bd7f9.svg";